<template>
  <div class="d-flex align-center">
    <!-- table icon -->
    <div v-if="showIcon" class="d-flex align-center">
      <img src="/assets/icon-table.png" style="width: 16px; height: 16px">
    </div>
    <!-- 이름 (일반 모드) -->
    <div v-if="!isModifyingName">
      <v-hover v-slot="{ hover }">
        <div class="d-flex align-center">
          <!-- title -->
          <div :class="showIcon ? 'pl-2' : ''" style="font-size: 15px">
            <div v-if="tableDatas[tableId].title">
              {{ tableDatas[tableId].title }}
            </div>
            <div v-else style="color: #90A4AE">
              {{ tableId+1 }}
            </div>
          </div>
          <div v-if="!hover || !canEdit" style="width: 20px"></div>
          <!-- 수정 버튼 -->
          <v-tooltip v-if="hover && canEdit" bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-flex align-center ml-1" style="width: 20px; height: 20px">
                <div @click.stop="clickModifyNameBtn()"
                  class="d-flex align-center justify-center"
                  :class="$store.getters.permissionLevel < 1 ? 'disabled-icon-btn' : 'default-icon-btn'"
                  style="width: 18px; height: 18px"
                >
                  <v-icon style="font-size: 15px">mdi-pencil</v-icon>
                </div>
              </div>
            </template>
            <span>{{ $store.getters.permissionLevel >= 1 ? '수정' : '수정 권한이 없습니다.' }}</span>
          </v-tooltip>
        </div>
      </v-hover>
    </div>
    <!-- 이름 (수정 모드) -->
    <div v-else class="d-flex align-center" style="width: 100%" v-click-outside="cancelModifyName">
      <!-- 수정창 -->
      <v-text-field
        v-model="tableDatas[tableId].title" @keyup.enter="modifyName()" @keyup.esc="cancelModifyName()" :style="{fontSize: '15px'}"
        class="modify-text-input mt-0 pt-0" style="width: 100%" hide-details autofocus color="#0D0E17"
      ></v-text-field>
      <!-- 확정 버튼 -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on" @click.stop="modifyName()"
            class="d-flex align-center justify-center ml-1"
            :class="!tableDatas[tableId].title || (tableDatas[tableId].title && !tableDatas[tableId].title.trim()) ? 'disabled-icon-btn' : 'default-icon-btn'"
            style="min-width: 18px; max-width: 18px; height: 18px"
          >
            <v-icon style="font-size: 15px">mdi-check</v-icon>
          </div>
        </template>
        <span>확인</span>
      </v-tooltip>
      <!-- 취소 버튼 -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on" @click.stop="cancelModifyName()"
            class="default-icon-btn d-flex align-center justify-center ml-1"
            style="min-width: 18px; max-width: 18px; height: 18px"
          >
            <v-icon style="font-size: 15px">mdi-close</v-icon>
          </div>
        </template>
        <span>취소</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http-common"

export default {
  name: "TableTitle",

  props: {
    dataPk: {
      type: Number,
      default: 0,
    },
    tableDatas: {
      type: Array,
      default: () => [],
    },
    tableId: {
      type: Number,
      default: 0,
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      isModifyingName: false,
      originName: '',
    }
  },

  methods: {
    clickModifyNameBtn() {
      console.log('clickModifyNameBtn')
      this.isModifyingName = true
      this.originName = this.tableDatas[this.tableId].title ? this.tableDatas[this.tableId].title : ''
    },
    modifyName() {
      console.log('modifyName')
      if (!this.tableDatas[this.tableId].title.trim()) {
        console.log('name is empty')
        return false
      }
      let rules = [{
        type: 'update_title',
        table_idx: this.tableId,
        value: this.tableDatas[this.tableId].title,
      }]
      let body = {
        db: 'multiTableData',
        pk: this.dataPk,
        rules: rules
      }
      console.log('body', body)
      http
      .post('annotation/edit-data/', body, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } })
      .then(res => {
        console.log('editData res', res)
        this.$store.commit('swalToast', {title: '수정되었습니다.', type: 'success'})
        this.isModifyingName = false
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && (err.response.status === 401 && !err.authRetryExhausted)) { // access token 만료
          this.methodRecall()
          .then(msg => {
            console.log(msg)
            this.modifyName() // method 재호출
          })
          .catch(err_msg => {
            console.log(err_msg)
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // this.$store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              this.$store.commit('logout')
              this.$router.push('/').catch(() => {})
            }
          })
        }
      })
    },
    cancelModifyName() {
      console.log('cancelModifyName')
      this.tableDatas[this.tableId].title = this.originName
      this.isModifyingName = false
    },
  },

  mounted() {
    // console.log('TableTitle mounted')
    // console.log('table', this.table)
  }
}
</script>

<style scoped>
.modify-text-input >>> .v-input__control .v-input__slot {
  min-height: 22.5px !important;
  height: 22.5px !important;
}
</style>